import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KakaoWorkUser } from '../../types/authData';

export enum ShareTabType {
  StartDt = 'StartDt',
  EndDt = 'EndDt',
  Target = 'Target',
}

export interface ResultState {
  shareTab: ShareTabType;
  targets: KakaoWorkUser[];
  deletedAll: string[];
  targetSize: number;
  waitOne: undefined | KakaoWorkUser[];
  firstAccess: boolean;
}

const initialState: ResultState = {
  shareTab: ShareTabType.StartDt,
  targets: [] as KakaoWorkUser[],
  deletedAll: [],
  targetSize: 0,
  waitOne: undefined,
  firstAccess: true,
};

export const shareSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {
    setShareTab(state, action: PayloadAction<ShareTabType>) {
      state.shareTab = action.payload;
    },
    setShareTargets(state, action: PayloadAction<KakaoWorkUser[]>) {
      if (action.payload) {
        state.targets = action.payload;
      }
    },
    setDeletedAll(state, action: PayloadAction<string>) {
      state.deletedAll.push(action.payload);
    },
    filterDeletedAll(state, action: PayloadAction<string>) {
      const newOne = state.deletedAll.filter((item: string) => item !== action.payload);
      state.deletedAll = [...newOne];
    },
    setTargetSize(state, action: PayloadAction<number>) {
      state.targetSize = action.payload;
    },
    setWaitOne(state, action: PayloadAction<KakaoWorkUser[] | undefined>) {
      state.waitOne = action.payload;
    },
    setFirstAccess(state, action: PayloadAction<boolean>) {
      state.firstAccess = action.payload;
    },
  },
});

export const {
  setShareTab,
  setShareTargets,
  setWaitOne,
  setDeletedAll,
  setTargetSize,
  setFirstAccess,
  filterDeletedAll,
} = shareSlice.actions;
export default shareSlice;
